<template>
  <div
    :style="{
      backgroundColor,
    }"
    class="main-loading"
  >
    <div class="slogan">
      <!-- todo 需要替换文案 -->
      <div class="slogan-title">
        {{ slogan }}
      </div>
    </div>
    <img
      src="@/assets/images/main_loading.gif"
      class="loading"
    />
  </div>
</template>

<script lang="ts">
import { useI18n } from '~/utils/i18n'

export default {
  name: 'MainLoading',
  components: {},
  props: {
    backgroundColor: {
      type: String,
      default: '#fff',
    },
  },
  setup() {
    return {
      slogan: useI18n().t(
        'financial.loan.baldr.credit.name'
      ),
    }
  },
}
</script>

<style lang="stylus" scoped>
.main-loading
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  padding-top 30vh
  z-index 799
  pointer-events none
  box-sizing border-box
  .slogan
    margin-bottom 40px
  .slogan-title
    margin-bottom 40px
    font-family DiDiSans-Pro-Bold
    font-size: 60px
    color color-primary
    text-align center
  .slogan-list
    display flex
    justify-content center
    align-items center
  .slogan-list_item
    // opacity: 0.8
    font-family DiDiSans-Pro-Medium
    font-size 22px
    color color-text-form
    margin 0 10px
  >>> .md-icon
    width 24px
    transform translate(0, 8px)
  .loading
    display block
    width 176px
    margin 0 auto
</style>
